<template>
  <vs-popup class="customer-sample-order-update-popup" title="UPDATE SAMPLE ORDER ITEMS" :active.sync="open"
    :buttons-hidden="true">
    <vx-card no-shadow>
      <div class="vx-row mb-3">
        <div class="vx-col w-full">
          <vs-table id="rm-order-item-table" :hoverFlat="true" :data="formulation_items" class="mb-8">

            <template slot="thead">
              <vs-th>FORMULATION CODE</vs-th>
              <vs-th width="15%" class="text-xs">PRICE (GBP/KG)</vs-th>
              <vs-th width="15%" class="text-xs">QUANTITY (GRAMS)</vs-th>
              <vs-th width="15%">NET VALUE (GBP)</vs-th>
              <vs-th width="15%" class="text-xs">ACTION</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr class="text-sm" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].formulation_code">
                  {{ data[indextr].formulation_code }}
                </vs-td>
                <vs-td :data="data[indextr].price">
                  <vs-input type="number" v-model="formulation_items[indextr].price" class="w-full" />
                </vs-td>
                <vs-td :data="data[indextr].quantity">
                  <vs-input type="number" v-model="formulation_items[indextr].quantity" class="w-full" />
                </vs-td>
                <vs-td>
                  {{ calculateNetValue(data[indextr]) }}
                </vs-td>
                <vs-td>
                  <div class="vx-row">
                    <vx-tooltip class="mr-2" text="Update quantity" position="top">
                      <vs-button @click="updateFormulationItems" :id="'update_button' + '' + indextr" size="small"
                        color="primary" type="border" icon-pack="feather" icon="icon-save"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip class="mr-2" text="Remove" position="top">
                      <vs-button @click="removeFormulationItem(tr.id)" :id="'remove_button' + '' + indextr" size="small"
                        color="danger" type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <hr>
          <h3 class="mt-8">Add new products to order</h3>
          <vs-table :hoverFlat="true" :max-items="(meta.per_page) ? meta.per_page : 10" :data="sample_product_list"
            :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

            <template slot="header">
              <vs-input icon-pack="feather" icon="icon-search" placeholder="Search" v-model="filters['search']"
                class="is-label-placeholder pl-1 pb-5 w-full md:w-1/4 xl:w-1/7 rounded-full" />
            </template>


            <template slot="thead">
              <vs-th width="15%" sort-key="created_at">PRODUCT CODE</vs-th>
              <vs-th width="10%" sort-key="town_state">NAME</vs-th>
              <vs-th>DESCRIPTION</vs-th>
              <vs-th width="15%">PRICE (GBP/KG)</vs-th>
              <vs-th width="15%">QUANTITY (GRAMS)</vs-th>
              <vs-th width="15%">NET VALUE (GBP)</vs-th>
              <vs-th width="10%">PRICING TYPE</vs-th>
              <vs-th width="10%" class="" v-can="'create-edit-sample-order'">ACTION</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="data[indextr].formulation_code">
                  {{ data[indextr].formulation_code }}
                </vs-td>

                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>

                <vs-td :data="data[indextr].description">
                  {{ data[indextr].description }}
                </vs-td>

                <vs-td>
                  <vs-input type="number" v-model="data[indextr].price" class="w-full" :name="indextr + 'price'" />
                </vs-td>
                <vs-td>
                  <vs-input type="number" v-model="data[indextr].quantity" class="w-full" :name="indextr + 'quantity'" />
                </vs-td>
                <vs-td>
                  {{ calculateNetValue(data[indextr]) }}
                </vs-td>
                <vs-td :data="data[indextr].pricing_type">
                    <vs-button size="small" color="primary" type="border" @click.stop="onClickPricingType(data[indextr], indextr)">{{ data[indextr].pricing_type }}</vs-button>
                  </vs-td>
                <vs-td v-can="'create-edit-sample-order'">
                  <div class="vx-row">
                    <vx-tooltip class="" text="Add to cart" position="top">
                      <vs-button :disabled="Number(tr.quantity) < 0 || !tr.quantity" :id="'add_button' + '' + indextr"
                        @click.stop="onClickAddToCart(data[indextr].id, data[indextr].quantity, data[indextr].price)" size="small"
                        color="primary" type="border" icon-pack="feather" icon="icon-plus">Add</vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>

          </vs-table>
          <vs-pagination :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5"></vs-pagination>
        </div>
      </div>
    </vx-card>
    <calculate-bespoke-prices ref="calculateBespokePrices" @onItemUpdated="onItemUpdated" account_currency="GBP"/>
    <calculate-list-prices ref="calculateListPrices" @onItemUpdated="onItemUpdated" account_currency="GBP"/>

  </vs-popup>
</template>

<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import Filter from '@/mixins/filter';
import Calculations from '@/mixins/Calculations';
import CalculateBespokePrices from '@/components/popups/customer/sample-orders/CalculateBespokePrices.vue';
import CalculateListPrices from '@/components/popups/customer/sample-orders/CalculateListPrices.vue';
const CustomerRepository = RepositoryFactory.get('customer')
const SettingsRepository = RepositoryFactory.get('settings');

export default {
  name: "UpdateCustomerSampleOrderItemsPopUp",
  data() {
    return {
      open: false,
      id: '',
      formulation_items: [],
      meta: {},
      sample_product_list: [],
      page: 1,
      filters: {},
      default_sample_item_price: 0,
      customerId: null,
      customerLeadId: null
    }
  },
  mixins: [SuccessMessage, ErrorMessages, Filter, Calculations],
  components: {
    CalculateBespokePrices,
    CalculateListPrices,
  },
  methods: {
    async openPopup(id, customer_id, formulation_items, isBlocked = false) {
      if (isBlocked) {
        this.$vs.dialog({
          color: 'danger',
          title: 'Action Not Allowed',
          text: 'This is a proforma account and an invoice has already been issued for this order. To change products, please cancel the invoice or create a new order and request Accounts to issue a credit note.',
          accept: null,
          acceptText: 'Close'
        })
        return
      }
      this.open = true;
      this.id = id;
      this.customerId = customer_id;
      await Promise.all([this.fetchDefaultPrice(), this.fetchOrderDetails()]);
      await this.fetchSampleList()
    },

    async updateFormulationItems() {
      this.$vs.loading();
      try {
        const payload = this.formulation_items.map(({ id, formulation_id, quantity, price }) => ({ id, formulation_id, quantity, price }));
        await CustomerRepository.updateSampleOrderItems(this.id, { sample_order_items: payload });
        this.showSuccessMessage('Sample order update successfully');
        await this.$parent.refreshData();
      } catch (error) {
        this.convertAndNotifyError(error);
      } finally {
        this.$vs.loading.close();
        this.open = false;
      }
    },

    async fetchSampleList() {
      try {
        this.$vs.loading();
        console.log(this.customerLeadId)
        const { data } = await CustomerRepository.getSampleList(this.customerLeadId ? null : this.customerId, this.page, this.filterQuery, 20, '');
        const existing_ids = this.formulation_items.map(({ formulation_id }) => formulation_id);
        this.sample_product_list = data.data.filter(({ id }) => !existing_ids.includes(id))
          .map((x) => {
            return {
              ...x,
              price_tiers: x.price,
              price: this.default_sample_item_price,
              quantity: 0
            }
          })
        this.meta = data.meta;
      } catch (error) {
        this.convertAndNotifyError(error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async onClickAddToCart(formulation_id, quantity, price) {
      this.$vs.loading();
      try {
        const payload = [...this.formulation_items, { formulation_id, quantity, price }]
          .map(({ id, formulation_id, quantity, price }) => ({ id, formulation_id, quantity, price }));

        await CustomerRepository.updateSampleOrderItems(this.id, { sample_order_items: payload });
        this.showSuccessMessage('Sample order update successfully');
        await Promise.all([this.$parent.refreshData(), this.fetchOrderDetails(), this.fetchSampleList()]);
      } catch (error) {
        this.convertAndNotifyError(error);
      } finally {
        this.$vs.loading.close();
      }
    },

    onClickPricingType(data, index){
      if(data.pricing_type === "Bespoke" || data.pricing_type === "Contract") {
        this.$refs.calculateBespokePrices.openPopup(data, index, false, this.customerId)
      }else if(data.pricing_type === "List") {
        this.$refs.calculateListPrices.openPopup(data, index, this.customerId)
      }
    },

    onItemUpdated(data, index){
        this.sample_product_list[index].price = data.price
        this.sample_product_list[index].quantity = data.quantity
    },

    async fetchOrderDetails() {
      try {
        const { data } = (await CustomerRepository.getSampleOrder(this.id)).data;
        this.formulation_items = data.formulation_items.map((item) => {
          return {
            ...item,
            price: item.price,
          }
        });
        this.customerLeadId = data.customer_lead ? data.customer_lead.id : null
      } catch (error) {
        this.convertAndNotifyError(error);
      }
    },

    calculateNetValue(item) {
      const quantityInKg = Number(item.quantity) / 1000;
      const unitPrice = Number(this.$options.filters.format_price(item.price, 1));
      return (quantityInKg * unitPrice).toFixed(2);
    },

    filterQueryUpdate() {
      this.fetchSampleList();
    },

    async removeFormulationItem(id) {
      this.$vs.loading();
      try {
        const payload = this.formulation_items
          .filter(({ id: itemId }) => itemId !== id)
          .map(({ id, formulation_id, quantity, price }) => ({ id, formulation_id, quantity, price }));

        await CustomerRepository.updateSampleOrderItems(this.id, { sample_order_items: payload });
        this.showSuccessMessage('Sample order update successfully');
        await Promise.all([this.fetchOrderDetails(), this.fetchSampleList(), this.$parent.refreshData()]);
      } catch (error) {
        this.convertAndNotifyError(error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async fetchDefaultPrice() {
        try {
          const settings = (await SettingsRepository.getTheItem('default_sample_item_price')).data.data
          this.default_sample_item_price = settings.default_sample_item_price
        } catch (e) {
          this.convertAndNotifyError(e)
        }
      }
  },
  watch: {
    page() {
      this.fetchSampleList()
    }
  },
}
</script>

<style scoped>
.customer-sample-order-update-popup>>>.vs-popup {
  min-height: 50% !important;
  min-width: 70% !important;
}
</style>
